import { IconBalanceScale, IconHandshake, IconUsers, IconFileSignature } from '../components/ui/icons';
import { MIN_INVESTMENT_LABEL } from '../config/paymentMethods';

/**
 * ⚖️ NOS VALEURS : égalité et principes de l'économie islamique (source unique)
 * Détail des règles de partage et des versets : src/data/sharingPrinciples.js.
 * Utilisé par l'accueil et la page « Qui sommes-nous ».
 */
export const VALUES = [
  {
    icon: IconBalanceScale, title: 'Justice et équité', tone: 'from-blue-700/85',
    photo: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    text: "Chacun reçoit sa juste part : la répartition est fixée d'avance et appliquée aux résultats réels. Personne n'est lésé."
  },
  {
    icon: IconHandshake, title: 'Sans intérêt, gains et pertes partagés', tone: 'from-green-700/85',
    photo: 'https://images.unsplash.com/photo-1593113598332-cd288d649433?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    text: "Aucun intérêt (ribâ) : investisseurs et entrepreneurs partagent les gains comme les pertes, selon ce qu'ils ont convenu."
  },
  {
    icon: IconUsers, title: 'Égalité des chances', tone: 'from-orange-600/85',
    photo: '/assets/media/secteurs/eau.jpg',
    text: `Les mêmes droits pour tous : femmes, jeunes, villes et campagnes, diaspora. Dès ${MIN_INVESTMENT_LABEL}, chacun peut investir.`
  },
  {
    icon: IconFileSignature, title: 'Confiance et parole tenue', tone: 'from-blue-900/85',
    photo: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    text: 'Chaque engagement est écrit et respecté, seules des activités licites et utiles sont financées, et les chiffres sont publiés.'
  }
];
